export default "__VITE_ASSET__CZRZK1Lk__"